import React from 'react';
import { Division } from './glossary.type';
import { compareNumerically } from '../../common/utils/common.util';
import SelectInput from '../SelectInput';

interface SelectDivisionFromGivenProps {
  selectedDivision: string | null;
  setSelectedDivision: (newVal: string | null) => void;
  divisions: Division[];
  disabled?: boolean;
  label?: string;
  readOnly?: boolean;
}

const SelectDivisionFromGiven: React.FC<SelectDivisionFromGivenProps> = ({
  selectedDivision,
  setSelectedDivision,
  divisions,
  disabled,
  label,
  readOnly,
}) => {
  const divisionOptions = divisions
    .sort((a, b) => compareNumerically(a.code, b.code))
    .map(division => ({ value: division.id, label: `${division.code} - ${division.name}` }));

  const list = [
    { value: 'no-change', label: 'No Change' }, // no action
    { value: '', label: 'None' },
    ...divisionOptions,
  ];

  return (
    <SelectInput
      label={label}
      selected={selectedDivision ?? 'no-change'}
      setSelected={newVal => {
        setSelectedDivision(newVal === 'no-change' ? selectedDivision : newVal === '' ? null : newVal);
      }}
      list={list}
      variant='standard'
      disabled={disabled || readOnly}
      sx={{ height: '100%', justifyContent: 'center' }}
    />
  );
};

export default SelectDivisionFromGiven;
